import { GET_INITIAL_CALL_INFO } from "../../Queries/GetInitialCallInfo";
import { getValueFromPath } from "../../IndexedDb/util.js";
import { GET_SIZE_AND_WEIGHT } from "../SizeAndWeightFrame/Query/SizeAndWeightQuery";
import { formatOfficerName } from "../../utils/utils";

export const officerHasInUseScales = async (
  officer,
  incident,
  user,
  client
) => {
  let sw = incident?.sizeAndWeight;
  let res = { hasAssociation: true, associationErrors: [] };

  if (!user?.id) {
    res.associationErrors.push("User not found");
    res.hasAssociation = true;
    return res;
  }
  if (!officer?.id) {
    res.hasAssociation = false;
    return res;
  }
  if (!incident?.id) {
    res.associationErrors.push("Incident not found");
    return res;
  }

  if (!sw?.id) {
    try {
      const { data } = await client.query({
        query: GET_INITIAL_CALL_INFO,
        variables: { incidentId: incident.id, originatorId: user.id },
        context: { timeout: 60000 },
        fetchPolicy: "network-only",
      });
      sw = getValueFromPath(data, "initialCallInfo.sizeAndWeight");
    } catch (err) {
      console.error("Error getting the size and weight ID", err);
      res.associationErrors.push("Error getting the size and weight ID", err);
      res.hasAssociation = true;
      return res;
    }
  }

  if (sw?.id) {
    try {
      const { data } = await client.query({
        query: GET_SIZE_AND_WEIGHT,
        variables: { sizeAndWeightId: sw.id, originatorId: user.id },
        context: { timeout: 60000 },
        fetchPolicy: "network-only",
      });
      sw = getValueFromPath(data, "getSizeAndWeight");
    } catch (err) {
      console.error("Error fetching the size and weight object", err);
      res.associationErrors.push(
        "Error fetching the size and weight object",
        err
      );
      res.hasAssociation = true;
      return res;
    }
  }

  const officerScales = officer?.deptAttribute?.scales || [];
  const swScales = sw?.scales || [];
  const scalesInUse = officerScales.filter(officerScale =>
    swScales.some(swScale => swScale.id === officerScale.id)
  );
  if (scalesInUse.length > 0) {
    const officerName = formatOfficerName(officer);
    res.hasAssociation = true;
    res.associationErrors.push(
      `You cannot remove ${officerName} from the incident because they have scales in use in the Size and Weight frame.`
    );
  } else {
    res.hasAssociation = false;
  }
  return res;
};
